import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=1a321e5c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a321e5c')) {
      api.createRecord('1a321e5c', component.options)
    } else {
      api.reload('1a321e5c', component.options)
    }
    module.hot.accept("./Tables.vue?vue&type=template&id=1a321e5c&", function () {
      api.rerender('1a321e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/basic-ui/Tables.vue"
export default component.exports